module.exports = __webpack_public_path__ + "img/product-hunt-fill.03709adf.svg";